import { useHistory } from "react-router-dom";
import { Layout } from "../../../shared/components/Layout";
import { FormTaxRate } from "../components/FormTaxRate";
import { PATH_TAXES, PATH_TAXES_EDIT_TAX_PROFILE } from "../paths";

export const RouteEditTaxRate = () => {
  const history = useHistory();

  return (
    <Layout title="Tax Withholdings">
      <FormTaxRate
        onEditTaxProfile={() => {
          history.push(PATH_TAXES_EDIT_TAX_PROFILE);
        }}
        onBack={() => {
          history.push(PATH_TAXES);
        }}
        onNext={() => {
          history.push(PATH_TAXES);
        }}
        isEdit
      />
    </Layout>
  );
};
